module.exports = __webpack_public_path__ + "static/media/windows.cd9774bc.svg";